import React from 'react';

import { Box, Pagination, Paper } from '@mui/material';
import { navigate } from 'gatsby';

// ********************************************************************************
type Props = {
  path: string;
  page: number;
  count: number;
};
export const ExperiencePagination: React.FC<Props> = ({ page, path, count }) => {
  // == Handlers ==================================================================
  const redirect = (page: number) => {
    if (page === 1) return navigate(path);

    // Some slugs have a trailing slash, so it needs to be removed
    if (path.endsWith('/')) path = path.slice(0, -1);
    navigate(`${path}/${page}`);
  };

  // == Render ==================================================================
  if (count <= 1) return null;
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', pt: 2, pb: '60px' }}>
      <Paper elevation={3} sx={{ display: 'flex', justifyContent: 'center', borderRadius: '8px', py: "5px" }}>
        <Pagination
          count={count}
          page={page + 1}
          color="primary"
          shape="rounded"
          size="medium"
          onChange={(_, value) => redirect(value)}
        />
      </Paper>
    </Box>
  );
};
